var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 10,
    height: 43,
    fill: "#DADBE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 16.5,
    width: 10,
    height: 43,
    transform: "rotate(90 43.5 16.5)",
    fill: "#DADBE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLarge);
export default __webpack_public_path__ + "static/media/plus-large.bd884e9efe5968abac31ca5fd7dd367b.svg";
export { ForwardRef as ReactComponent };